var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0_449_1093)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_449_1093",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_449_1093",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_449_1093",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAAcRJREFUeAHt2s9KwzAAB2DBp1HZi3vxz0l9hjX4Dl2b3oZ68zKJ0MNYD0u2sKDfYBRGs8L3S5MWfldXPgQIECBAgAABAgQIECBAgAABAgQIECBAgACBfywQ4/vdNITn2IePaQg733KDZBiH8BRjuC2aUlO/XsVN9yWE8hCW7H5N+/UqO5RxE96W/tBvZwio716zAtnt7q/jGL7hnwF/YalPtsn46FAEUieIeYJnB5KSs2TVCyUO4eXou2M+0aZeJ5C46T6T7eycdUyPaGO/fpyGbjvfbo6lQXXbqe8exrG7yQrByQQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgROE9B+L638HI7Tfl/o1LbQKdN+bzEY7ffDJeSSd0t22Vr7vW6A2YGkRwHt93qhaL83tI9ovzcThvb7aS9hRhMgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBQKaL+fryyn/d5MH2s/VO33FoPRft+fpZdsvqdrZ5ettd/rBpgdSHoG0H6vF4r2e0P7iPZ7M2Fovxe+fRlGgAABAgQIECBAgAABAgQIECBAgAABAgQI/DGBH91ckBfI0FHKAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menuIcon.5dad07e8fc5a1582b7fbdf8ba62daec9.svg";
export { ForwardRef as ReactComponent };